import { TableHeader } from "../models/table-header";
import { Subscription } from "rxjs";
import { AlertService } from "../services/alert.service";

export class BasePaginationComponent {
  subscriptions: Subscription[] = [];
  prevHead?: TableHeader = undefined;
  sort = "CreatedDate";
  direction = "desc";
  search = "";
  page = 1;
  pageSize = 10;
  totalPage = 0;

  constructor(protected alertService: AlertService) {}
  get isDescending(): boolean {
    return this.direction === "desc";
  }
  get isLoading(): boolean {
    return this.alertService.isLoadingInProgress;
  }

  refresh(): void {
    this.search = "";
    this.page = 1;
    this.totalPage = 1;
    this.getData();
  }

  changePage(page: number): void {
    this.page = page;
    this.getData();
  }

  sortData(head: TableHeader): void {
    if (!head.sortable) {
      return;
    }
    if (this.sort === head.sort) {
      this.prevHead = head;
      if (this.direction === "desc") {
        this.direction = "asc";
        this.prevHead.sortingDirection = true;
      } else {
        this.direction = "desc";
        this.prevHead.sortingDirection = false;
      }
    } else {
      if (this.prevHead) {
        this.prevHead.revertSorting();
        this.prevHead = undefined;
      }
      this.sort = head.sort;
      this.direction = "desc";
      this.prevHead = head;
      this.prevHead.sortingDirection = false;
    }
    this.getData();
  }

  onSearchChanged(search: string): void {
    this.search = search;
    this.getData();
  }

  protected getData(): void {}

  protected initialize(): void {}
}
